export const actionTypes = {
  GET_SHAREHOLDER_RECORDS_START: 'GET_SHAREHOLDER_RECORDS_START',
  GET_SHAREHOLDER_RECORDS_SUCCESS: 'GET_SHAREHOLDER_RECORDS_SUCCESS',
  GET_SHAREHOLDER_RECORDS_FINISH: 'GET_SHAREHOLDER_RECORDS_FINISH',
}
